export default "__VITE_ASSET__C8EA1qE3__"